import { cn } from '~/lib/utils';

export type VerifyStatus = 'valid' | 'invalid' | 'error' | 'idle' | 'loading';

interface VerifyBadgeProps {
  status: VerifyStatus;
  label: string;
}

const STATUS_STYLES: Record<VerifyStatus, string> = {
  valid: 'bg-green-100 text-green-800',
  invalid: 'bg-red-100 text-red-800',
  error: 'bg-yellow-100 text-yellow-800',
  idle: 'bg-secondary text-secondary-foreground',
  loading: 'bg-secondary text-secondary-foreground animate-pulse'
};

export function VerifyBadge({ status, label }: VerifyBadgeProps): React.ReactNode {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-medium',
        STATUS_STYLES[status]
      )}
    >
      {label}
    </span>
  );
}
